import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  LOCALE_ID,
  NgModule
} from '@angular/core';
import { NewRelicErrorHandler } from './shared/services/newrelic';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LIMIT } from '@authority-labs/constants';
import { TranslocoService } from '@ngneat/transloco';
import { he } from 'date-fns/locale';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { he_IL, NZ_DATE_LOCALE, NZ_I18N } from 'ng-zorro-antd/i18n';
import { DateFnsConfigurationService } from 'ngx-date-fns';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardService } from './auth/authentication.guard';
import { AuthInterceptorService } from './auth/authentication.interceptor';
import { MaterialModule } from './material.module';
import { InspectionsModule } from './modules/inspections/inspections.module';
import { TranslocoRootModule } from './modules/transloco/transloco-root.module';
import { NgZorroModule } from './ng-zorro.module';
import { ConfigurationService } from './shared/services/configuration/configuration.service';
import { EmailsService } from './shared/services/emails';

// registerLocaleData(localeHe, 'he-IL', localeHeExtra);
const fnsConfig = new DateFnsConfigurationService();
fnsConfig.setLocale(he);

const ngZorroConfig: NzConfig = {
  message: { nzDirection: 'rtl' },
  notification: {
    nzMaxStack: LIMIT.MAX_NOTIFICATION_QUEUE_SIZE,
    nzDirection: 'rtl'
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    MaterialModule,
    NgZorroModule,
    InspectionsModule,
    TranslocoRootModule
  ],
  providers: [
    AuthGuardService,
    ConfigurationService,
    EmailsService,
    { provide: LOCALE_ID, useValue: 'he' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'ILS' },
    { provide: MAT_DATE_LOCALE, useValue: 'he-IL' },
    { provide: NZ_DATE_LOCALE, useValue: he },
    { provide: NZ_I18N, useValue: he_IL },
    { provide: DateFnsConfigurationService, useValue: fnsConfig },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: preloadLang,
      deps: [TranslocoService]
    },
    // {
    //   provide: APP_INITIALIZER,
    //   multi: true,
    //   useFactory: loadConfig,
    //   deps: [ConfigurationService]
    // }
    { provide: ErrorHandler, useClass: NewRelicErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

export function preloadLang(transloco: TranslocoService) {
  return function () {
    return transloco.load('he').toPromise();
  };
}

// export function loadConfig(configService: ConfigurationService) {
//   return function () {
//     return configService.getAllConfig().toPromise();
//   };
// }
